import * as api from "./client";

export type EmbargoTextKey = "banner" | "row_notice";

export type EmbargoText = {
  key: EmbargoTextKey;
  /** Carries a {launchDate} token, replaced by the edition's launch date before display. */
  content: string;
  updatedAt: string;
  updatedBy: string | null;
};

export type EmbargoTextsResponse = {
  texts: EmbargoText[];
  requestId?: string | null;
};

export type SaveEmbargoTextResponse = {
  text: EmbargoText;
  requestId?: string | null;
};

export const LAUNCH_DATE_TOKEN = "{launchDate}";

/** Max length marketing-api accepts, mirrored so the panel refuses before the round trip. */
export const EMBARGO_TEXT_MAX_LENGTH = 1000;

/**
 * The same rule marketing-api applies on save. The copy-template panel next door uses
 * `{{name}}`, so an editor writes `{{launchDate}}` out of habit — which contains the token
 * and would render the date wrapped in braces. Removing the token and looking for what is
 * left catches that, a misspelt token, and any stray brace.
 */
export function embargoTextError(content: string): string | null {
  if (content.trim().length === 0) return "The text cannot be empty";
  if (content.length > EMBARGO_TEXT_MAX_LENGTH) {
    return `The text must be ${EMBARGO_TEXT_MAX_LENGTH} characters or fewer`;
  }
  if (!content.includes(LAUNCH_DATE_TOKEN)) {
    return `The text must carry ${LAUNCH_DATE_TOKEN}, or the firm reads a notice naming no date`;
  }
  if (/[{}]/.test(content.replaceAll(LAUNCH_DATE_TOKEN, ""))) {
    return `The only braces allowed are the ones around ${LAUNCH_DATE_TOKEN}`;
  }
  return null;
}

export const marketingEmbargoTexts = {
  get: async (): Promise<EmbargoTextsResponse> => {
    return api.get<EmbargoTextsResponse>("/v1/embargo-texts");
  },

  save: async (key: EmbargoTextKey, content: string): Promise<SaveEmbargoTextResponse> => {
    return api.put<SaveEmbargoTextResponse>("/v1/embargo-texts", { key, content });
  },
};
